export default __webpack_public_path__ + "static/media/9_Offener_Brief_Legalisierung_Jetzt_Kandidatinnen_AGH.aa1b529b.pdf";